<template>
  <div class="usage-development">
    <BaseChart
      height="250px"
      chart-height="150px"
      dark
      title="Usage development"
      :chart-data="mergedChartData"
      :subtitle="subtitle"
    >
      <template #widget-options>
        <slot name="widget-options"></slot>
      </template>
    </BaseChart>
  </div>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'
import { chart, xAxis, yAxis } from '@/reusable/base-chart/chart-data'

const customChartData = {
  chart: chart(),
  xAxis: xAxis({ lineColor: '#9A9FAE' }, 'white'),
  yAxis: yAxis({}, 'white', undefined, '#9A9FAE'),
  plotOptions: {
    series: {
      color: 'white',
      marker: {
        radius: 6
      }
    }
  }
}

export default {
  mixins: [commonPropertiesMixin('usage-development', customChartData)],

  computed: {
    subtitle() {
      if (!this.subscription) return
      return this.subscription.usage_column.value
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

>>> .chart {
  background $lm-light-cyan !important

  .header {
    color white !important
  }
}
</style>
